var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tablePage',_vm._b({on:{"event":function($event){return _vm.$emit('event', $event)}}},'tablePage',{defsEndpoint: _vm.endpoint, title: _vm.title, parentData: _vm.parentData},false))}
var staticRenderFns = []

export { render, staticRenderFns }